import { Table } from 'semantic-ui-react';
import EditListingModal from './EditListingModal';

const ListingSearchPageTable = ({ listings }) => (
  <Table selectable compact="very" size="small">
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Firm</Table.HeaderCell>
        <Table.HeaderCell>Address</Table.HeaderCell>
        <Table.HeaderCell>Description 1</Table.HeaderCell>
        <Table.HeaderCell>Description 2</Table.HeaderCell>
        <Table.HeaderCell>Type</Table.HeaderCell>
        <Table.HeaderCell>City</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {listings.map((listing, idx) => (
        <EditListingModal
          trigger={
            <Table.Row key={idx}>
              <Table.Cell>{listing.firm.name}</Table.Cell>
              <Table.Cell>{listing.address}</Table.Cell>
              <Table.Cell>{listing.description1}</Table.Cell>
              <Table.Cell>{listing.description2}</Table.Cell>
              <Table.Cell>{listing.type}</Table.Cell>
              <Table.Cell>{listing.city}</Table.Cell>
            </Table.Row>
          }
          item={listing}
          key={idx}
        />
      ))}
    </Table.Body>
  </Table>
);

export default ListingSearchPageTable;
